"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _get = _interopRequireDefault(require("lodash/get"));
var _reduxForm = require("redux-form");
var _reactRouterDom = require("react-router-dom");
var _withAuthentication = _interopRequireDefault(require("../../hocs/withAuthentication"));
var _instrumentActions = require("../../redux/actions/instrumentActions");
var _sidePaneActions = require("../../redux/actions/sidePaneActions");
var _DigitalAssetsOfferingProfilePage = _interopRequireDefault(require("./DigitalAssetsOfferingProfilePage"));
var _productActions = require("../../redux/actions/productActions");
var _digitalAssetsSelectors = require("../../redux/selectors/digitalAssetsSelectors");
var _config = _interopRequireDefault(require("../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DefaultProfileURL = _config["default"].DigitalAssets.DefaultProfileURL;
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var ProductId = parseInt((0, _get["default"])(ownProps, 'match.params.id', 0));
  var selectedProduct = (0, _get["default"])(state, 'apexCore.product.products', []).find(function (i) {
    return i.ProductId === ProductId;
  }) || {};
  var selectedInstrument = (0, _digitalAssetsSelectors.selectedDigitalAssetInstrumentSelector)(state, {
    ProductId: ProductId
  }) || {};
  var digitalAsset = (0, _digitalAssetsSelectors.digitalAssetSelector)(state, {
    ProductId: ProductId
  });
  return {
    ProductId: ProductId,
    selectedProduct: selectedProduct,
    selectedInstrument: selectedInstrument,
    selectedInstrumentId: selectedInstrument.InstrumentId,
    digitalAsset: digitalAsset,
    OfferingProfileURL: digitalAsset.OfferingProfileURL || DefaultProfileURL,
    price: (0, _get["default"])(state, ['apexCore', 'level1', state.apexCore.instrument.selectedInstrumentId, 'BestOffer'], 0)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getProductAttributes: function getProductAttributes(payload) {
      return dispatch((0, _productActions.getProductAttributes)(payload));
    },
    openSendReceiveSidePane: function openSendReceiveSidePane(product, isBuySide) {
      dispatch((0, _sidePaneActions.openSidePane)('AdvancedOrder', {
        hideHeader: true,
        product: product
      }));
      // Update form after it gets initialized by component mounting.
      setTimeout(function () {
        dispatch((0, _reduxForm.change)('advancedOrderEntry', 'side', isBuySide));
      }, 1);
    },
    selectInstrument: function selectInstrument(payload) {
      return dispatch((0, _instrumentActions.selectInstrument)(parseInt(payload, 10)));
    }
  };
};
var _default = exports["default"] = (0, _withAuthentication["default"])((0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_DigitalAssetsOfferingProfilePage["default"])));